<div class="gap4 flex w-full flex-col rounded-2xl border-2 border-dashed border-neutral-300 p-3">
  @if (vendorPackageName()) {
    <h4>{{ vendorPackageName() }}</h4>
  }
  @if (internalDescription()) {
    <pre class="text-wrap">{{ internalDescription() }}</pre>
  }
</div>
